export const platformAdminDashboard = {
  title: "AIRange プラットフォーム管理",
  subtitle: "試験業務管理から分離された靶場プラットフォームの制御面です。",
  summaryOverall: "プラットフォーム状態: {value}",
  summaryOnline: "オンライン構成: {count}",
  summaryChecks: "確認件数: {count}",
  summaryIdentityPhase: "認証フェーズ: {value}",
  summaryAssetPhase: "資産フェーズ: {value}",
  summaryExecutionPhase: "実行フェーズ: {value}",
  summaryIdentityRemediation: "認証是正: {count}",
  summaryAssetRemediation: "資産是正: {count}",
  kpiOverall: "プラットフォーム状態",
  kpiOnline: "オンライン構成",
  kpiChecks: "確認件数",
  kpiIdentityRemediation: "認証是正",
  kpiAssetRemediation: "資産是正",
  governanceTitle: "ガバナンス概要",
  messages: {
    loadFailed: "プラットフォーム概要の読み込みに失敗しました",
  },
  identityGovernanceTitle: "認証統治サマリー",
  assetGovernanceTitle: "資産統治サマリー",
  governanceWarnings: "警告項目",
  governanceCritical: "重大項目",
  governanceIssueActiveCredentials: "有効資格情報を発行",
  governanceConfigureAccessGrants: "アクセス権を設定",
  governanceConfigureRoleMappings: "ロールマッピングを設定",
  governanceObjectSpaceItems: "オブジェクト空間是正",
  governanceReferenceItems: "参照是正",
  governanceConfigureSpaceGrants: "空間権限を設定",
  governanceEnableSpaceGovernance: "オブジェクト空間を統治化",
  governanceNormalizeReferenceScope: "参照スコープを正規化",
  openIdentity: "認証統治へ",
  openAssets: "資産統治へ",
  openCenters: "入口とセンターを開く",
  openOpsCenter: "運用センターを開く",
  opsCenterNotice:
    "このページはプラットフォーム概要と入口サマリーのみを表示します。実行時の接続状態の真相は運用センターで確認してください。",
  applicationsTitle: "業務入口",
  centersTitle: "プラットフォーム入口とセンター",
  openConsole: "管理画面へ",
} as const;
